import * as $ from "jquery";
import "jquery-match-height/jquery.matchHeight.js";
import '@types/jquery-match-height';

$(document).ready(function () {
  $(".incident-communication-columns").matchHeight({
    byRow: false,
  });
  $(".incident-communication-bottom-column").matchHeight({
    byRow: false,
  });
  $(".best-integrations-practices").matchHeight({
    byRow: false,
  });
  $(".incident-communication-top-container").matchHeight({
    byRow: false,
  });
  $(".incident-communication-top-content").matchHeight({
    byRow: false,
  });
  $(".bottom-equal-height").matchHeight({
    byRow: false,
  });
  $(".integration-practices-alignment").matchHeight({
    byRow: false,
  });
  $(".incident-communication-bottom-content").matchHeight({
    byRow: false,
  });
});
